export default __webpack_public_path__ + "static/media/verify.afd2f9dc.svg";